// Apple-style spring easing
export const MOTION_TRANSITION = {
  duration: 0.5,
  ease: [0.32, 0.72, 0, 1],
} as const;
